import { LinkProps } from 'react-router-dom'
import { NavLink } from './Elements'

type Props = {
  shouldShowTransactions?: boolean
  shouldShowReports?: boolean
  onNavLinkClick: () => void
  LinkComponent: React.FC<LinkProps> | typeof NavLink
}

const CasNav: React.FC<Props> = ({
  onNavLinkClick,
  shouldShowTransactions = true,
  shouldShowReports = true,
  LinkComponent,
}) => {
  return (
    <>
      {shouldShowTransactions && (
        <LinkComponent to="/transactions" onClick={onNavLinkClick}>
          Transactions
        </LinkComponent>
      )}
      {shouldShowReports && (
        <>
          <LinkComponent onClick={onNavLinkClick} to="/reports">
            Reports
          </LinkComponent>
          <LinkComponent onClick={onNavLinkClick} to="/holdings">
            Holdings
          </LinkComponent>
          <LinkComponent onClick={onNavLinkClick} to="/taxes">
            Taxes
          </LinkComponent>
        </>
      )}
    </>
  )
}

export default CasNav
